var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-input-primary-button',{staticClass:"ml-2",attrs:{"label":_vm.label,"icon":"mdi-microsoft-excel"},on:{"click":_vm.processExcel}})}
var staticRenderFns = []

export { render, staticRenderFns }